import React from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress } from '@material-ui/core';
import { PowerSettingsNew, CheckCircle } from '@material-ui/icons';
import clsx from 'clsx';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import styles from './ServiceStatus.module.scss';

const ServiceStatus = ({ isActive, onToggle, isLoading, wasInitiallyActive }) => {
  const localizeMessage = useLocalizedMessage();
  return (
    <div className={clsx(styles.card, isActive ? styles.active : styles.inactive)}>
      <div className={clsx(styles.icon, isActive && !isLoading && styles.iconActive)}>
        {!isLoading && (isActive ? <CheckCircle fontSize="inherit" /> : <PowerSettingsNew fontSize="inherit" />)}
      </div>

      <div className={styles.title}>
        {isLoading
          ? localizeMessage('cloud.home.service.checking')
          : localizeMessage('cloud.home.service.title')}
      </div>

      <div className={clsx(styles.statusText, isActive ? styles.statusActive : styles.statusInactive)}>
        {!isLoading && (isActive
          ? localizeMessage('cloud.home.service.active')
          : localizeMessage('cloud.home.service.inactive'))}
      </div>

      <div className={styles.controls}>
        {isLoading ? (
          <CircularProgress size={24} />
        ) : (
          !wasInitiallyActive && (
            <Button
              variant="contained"
              color="primary"
              disabled={isActive}
              onClick={() => onToggle(true)}
              className={isActive ? styles.enabledButton : ''}
            >
              {isActive
                ? localizeMessage('cloud.home.service.enabled')
                : localizeMessage('cloud.home.service.enable')}
            </Button>
          )
        )}
      </div>
    </div>
  );
};

ServiceStatus.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  wasInitiallyActive: PropTypes.bool,
};

ServiceStatus.defaultProps = {
  isLoading: false,
  wasInitiallyActive: false,
};

export default ServiceStatus;
